/* eslint-disable react/jsx-props-no-spreading */
import isNumber from 'lodash/isNumber';
import plural from 'plural-ru';
import React from 'react';
import { GroupBase } from 'react-select';
import { MenuListProps } from 'react-select';
import { components } from 'react-select';
import styles from './MenuList.module.scss';

const pluralVariant = (count: number) =>
    plural(count, '%d вариант', '%d варианта', '%d вариантов');

export interface MenuListCustomProps {
    moreOptionsCount: number | null;
}

export const MenuList = <
    Option,
    IsMulti extends boolean = boolean,
    Group extends GroupBase<Option> = GroupBase<Option>
>({
    children,
    ...props
}: MenuListProps<Option, IsMulti, Group>) => {
    const {
        selectProps: { customProps },
    } = props;

    const { moreOptionsCount } = customProps as MenuListCustomProps;

    const hasMore = isNumber(moreOptionsCount) && moreOptionsCount > 0;

    return (
        <components.MenuList {...props}>
            {children}
            {hasMore && (
                <div className={styles.andMore}>
                    ...и еще {pluralVariant(moreOptionsCount)}
                </div>
            )}
        </components.MenuList>
    );
};
